import { useEffect, useState } from "react";
import "./CreateNewProject.scss";
import { Button, Emissions, ProjectInformation, Stepper } from "..";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../../routes/routes.constatns";
import { Financials } from "../Financials/Financials";
import { ProjectResults } from "../ProjectResults/ProjectResults";
import { useDispatch, useSelector } from "react-redux";
import { analyseProjectsData, projectTypeEnum } from "../../util/constants";
import {
  dropProjectState,
  nextTab,
  previousTab,
  setProjectId,
  setIsNextTabButtonDisabled,
  setTabIndex,
  setCurrentTab,
  setIsEditProject,
  setProjectName,
  setProjectType,
  setProjectDescrption,
  setProjectTags,
  setIsValidated,
} from "../../store/slices/projectSlice";
import {
  createProject,
  // createM3Project,
  updateProject,
  getDistinctProjectsNames,
  updateProjectStep,
  getColumnValueFlags,
  SaveUserModuleLock,
  getProjectDetailsById,
  SetProjectStatustoFinalize,
} from "../../store/services/project.service";
import { TabNavigation } from "./components/TabNavigation/TabNavigation";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { ConfirmationModal } from "../CommonUIComponents/ConfirmationModal/ConfimationModal";
import { setWafErrorFlag } from "../../store/slices/projectSlice";

export function CreateNewProject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const steps = useSelector((state) => state.stepper.steps);
  const engagement = useSelector((state) => state.engagement.engagement);
  const selectedRegion = useSelector(
    (state) => state.engagement.selectedRegion
  );
  const stepIndex = useSelector((state) => state.engagement.stepIndex);
  const currentStep = useSelector((state) => state.engagement.currentStep);
  const currentTab = useSelector((state) => state.project.currentTab);
  const tabIndex = useSelector((state) => state.project.tabIndex);
  const project = useSelector((state) => state.project.project);
  const user = useSelector((state) => state.user.user);
  const isEditProject = useSelector((state) => state.project.isEditProject);
  const [isDataSaveInProgress, setIsDataSaveInProgress] = useState(false);
  const [isfinalModalOpen, setIsFinalModalOpen] = useState(false);
  const isNextTabButtonDisabled = useSelector(
    (state) => state.project.isNextTabButtonDisabled
  );
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  let refreshIntervalId = undefined;
  let refreshIntervalCount = 0;
  const lockingData = useSelector((state) => state.project?.lockingData);
  let heading =
    project.projectType === 1
      ? projectTypeEnum.Reduce
      : project.projectType === 2
      ? projectTypeEnum.Replace
      : projectTypeEnum.Compensate;

  useEffect(() => {
    if (state?.projectStatusId) {
      let index = state?.projectStatusId >= 4 ? 3 : state?.projectStatusId;
      dispatch(setTabIndex({ index: index }));
      dispatch(setCurrentTab({ currentTab: index }));
      state?.isValidated === "N" &&
        dispatch(setIsValidated({ isValidated: false }));
    }
  }, [state?.projectStatusId]);

  useEffect(() => {
    if (state?.projectId) {
      getProjectDetails(state?.projectId);
    }
  }, [state?.projectId]);

  async function getProjectDetails(projectId) {
    const request = { projectID: projectId };
    const data = await getProjectDetailsById({ request });
    dispatch(setProjectName({ name: data.data.projectName }));
    dispatch(setProjectType({ type: data.data.projectTypeID }));
    dispatch(setProjectDescrption({ descrp: data.data.projectDescription }));
    let tagArray = [];
    data.data.tags &&
      data.data.tags.map((item) => tagArray.push({ label: item, value: item }));
    dispatch(setProjectTags({ tags: tagArray }));
    dispatch(setProjectId({ id: projectId }));
    dispatch(setIsEditProject({ isEdit: true }));
  }

  const tabSteps = [
    {
      stepName: "Step 1: Project information",
      stepHeading: "Create project",
      stepComponent: (
        <ProjectInformation onTabStepCompleted={onTabStepCompleted} />
      ),
    },
    {
      stepName: "Step 2: Emissions",
      stepHeading: "Edit project `${} (replace)",
      stepComponent: <Emissions onTabStepCompleted={onTabStepCompleted} />,
    },
    {
      stepName: "Step 3: Financials",
      stepHeading: "Edit project electrification (replace)",
      stepComponent: <Financials onTabStepCompleted={onTabStepCompleted} />,
    },
    {
      stepName: "Step 4: Results",
      stepHeading: "Edit project electrification (replace)",
      stepComponent: <ProjectResults />,
    },
  ];

  function handleCancelClick() {
    dispatch(setWafErrorFlag(false));
    dispatch(dropProjectState());
    navigate(`/${routes.createNewEngagement}`, {
      state: {
        engagementId: engagement.id,
        regionId: selectedRegion?.id,
      },
      gestureEnabled: false,
    });
  }

  async function onSaveAndNext() {
    dispatch(setWafErrorFlag(false));
    let projectId = state?.projectId;
    setIsDataSaveInProgress(true);
    let saveFlag = true;
    try {
      if (currentTab === 0) {
        if (isEditProject || project.projectId) {
          projectId = project.projectId;
          let tagArray = [];
          project.projectTags.length > 0 &&
            project.projectTags.forEach((item) => {
              tagArray.push({ tagName: item.value });
            });
          const payload = {
            projectID: projectId,
            createdBy: user.username,
            projectTags: tagArray,
            projectDescription: project.projectDescrption.replace(/and\s+(\d+)/g, 'and$1'),
            projectName: project.projectName,
            engagementId: engagement.id,
          };
          const data = await updateProject({ payload });
          if (data?.statusCode === 400) {
            saveFlag = false;
          }
        } else {
          const isDuplicateProject = await handlecheckIfProjectNameExist();
          if (!isDuplicateProject) {
            let tagArray = [];
            project.projectTags.length > 0 &&
              project.projectTags.forEach((item) => {
                tagArray.push({ tagName: item.value });
              });
            const request = {
              engagementId: engagement.id,
              projectTypeId: parseInt(project.projectType),
              projectStatus: 1,
              projectDescription: project.projectDescrption
                ? project.projectDescrption.replace(/and\s+(\d+)/g, 'and$1')
                : "",
              createdBy: user.username,
              projectName: project.projectName,
              projectTags: tagArray,
            };
            const response = await createProject({ request });
            dispatch(setProjectId({ id: response?.data?.projectId }));
            
            projectId = response?.data?.projectId;
            const flagsPayload = {
              columnName: "Create",
              tableName: "Project",
              id: response?.data?.projectId,
            };
            const lockRequest = {
              moduleName: "Project",
              lockedBy: user.username,
              id: 0,
              lockGuid: response?.data?.projectId,
            };
            SaveUserModuleLock(lockRequest);
            try {
              refreshIntervalId = window.setInterval(
                checkFlags(flagsPayload),
                2000
              );
            } catch (error) {
              if (refreshIntervalId) {
                window.clearInterval(refreshIntervalId);
                refreshIntervalId = undefined;
              }
              setIsDataSaveInProgress(false);
            }
          }
        }
      }

      if (saveFlag) {
        if (currentTab === tabIndex && currentTab !== 3) {
          if(projectId || project?.projectId) {
              project.projectStatus !== 5 &&
              (await updateProjectStep({
                request: {
                  projectId: projectId ?? project?.projectId,
                  stepId: tabIndex + 1,
                },
              }));
              dispatch(setTabIndex({ index: tabIndex + 1 }));
          }
        }
        if (currentTab === 2) {
          project.projectStatus <= 4 &&
            (await updateProjectStep({
              request: {
                projectId: projectId ?? project?.projectId,
                stepId: tabIndex + 1,
              },
            }));
        }
        if (currentTab === 3) {
          setIsFinalModalOpen(true);
        } else {
          dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
          if(projectId || project?.projectId) 
            dispatch(nextTab());
        }
      }  

      setIsDataSaveInProgress(false);
    } catch (error) {
      setIsDataSaveInProgress(false);
    }
  }

  const checkFlags = async (flagsPayload) => {
    refreshIntervalCount++;
    if (refreshIntervalCount > 30) {
      window.clearInterval(refreshIntervalId);
      refreshIntervalId = undefined;
      return;
    }
    const response = await getColumnValueFlags({ flagsPayload });
    if (response.columnValue === "3") {
      if (refreshIntervalId) {
        window.clearInterval(refreshIntervalId);
        refreshIntervalId = undefined;
      }
      setIsDataSaveInProgress(false);
    }
  };

  const handlecheckIfProjectNameExist = async (event) => {
    if (!project?.projectName?.trim()) {
      dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
      return;
    };

    const data = await getDistinctProjectsNames({
      request: { engagementId: engagement.id },
    });
    const dataArray = data.map((v) => v?.trim()?.toLowerCase());

    const duplicateProjectName = dataArray.includes(
      project?.projectName?.trim()?.toLowerCase()
    )
      ? true
      : false;

    if (duplicateProjectName) {
      dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
    }

    return duplicateProjectName;
  };

  function onPrevious() {
    if (currentTab === 1) {
      dispatch(setIsEditProject({ isEdit: true }));
    }
    dispatch(previousTab());
  }

  function onTabStepCompleted() {
    // dispatch(setIsNextTabButtonDisabled());
  }

  const finalise = async () => {
    const request = {
      projectId: project.projectId,
    };
    let data = await SetProjectStatustoFinalize({ request });
    handleCancelClick();
  };

  return (
    <div className="new-project">
      <div className="new-project-header">
        <div className="new-project-header-title">
          {steps[currentStep]?.stepHeading}
        </div>
        <div className="new-project-header-stepper">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            stepIndex={stepIndex}
          />
        </div>
      </div>

      <div className="new-project-content">
        <div className="new-project-content-header">
          <div className="new-project-content-header-main">
            <span className="new-project-content-header-main-analyse">
              {analyseProjectsData}
            </span>
            <span>{">"}</span>
            <span>
              {currentTab === 0
                ? "Create project"
                : "Edit project " + project.projectName + " (" + heading + ")"}
            </span>
          </div>
          <span className="new-project-content-header-desc"></span>
        </div>
        <div className="new-project-content-body">
          <TabNavigation
            tabSteps={tabSteps}
            currentTab={currentTab}
            tabIndex={tabIndex}
          />
          {tabSteps[currentTab]?.stepComponent}
          <div className="new-project-footer">
            <Button variant="secondary" onClick={handleCancelClick}>
              {/* {"Cancel"} */}
              {currentTab !== 3 ? "Close" : "Save"}
            </Button>
            <div className="new-engagement-footer-nav-buttons">
              {currentTab !== 0 ? (
                <Button onClick={onPrevious} variant="secondary">
                  {"Previous"}
                </Button>
              ) : (
                <></>
              )}

              {currentTab !== 3 ? (
                <LoadingIndicatorEmbed show={isDataSaveInProgress}>
                  <Button
                    onClick={onSaveAndNext}
                    variant="primary"
                    disabled={wafErrorFlag ||
                      isNextTabButtonDisabled ||
                      isDataSaveInProgress ||
                      (state?.projectStatusId === 5 && currentTab === 3) ||
                      (currentTab === 3 &&
                        lockingData?.data?.lockStatus === 1 &&
                        lockingData?.data?.lockedBy !== user.username)
                    }
                  >
                    {"Next"}
                  </Button>
                </LoadingIndicatorEmbed>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        isModalVisible={isfinalModalOpen}
        onClose={() => setIsFinalModalOpen(false)}
        onConfirm={() => finalise()}
        modalHeaderText={"Finalise project"}
        modalBodyText={
          "Upon confirmation, the finalized project will appear in Module 4 for project creation."
        }
      />
    </div>
  );
}
